module.exports = __webpack_public_path__ + "img/intro3.e999ed6a.png";